<template>
  <div class="terms-container">
    <div class="z11 uppercase">CLARIFICATION TEXT ABOUT THE COOKIES</div>

    <p class="z11">
      As ARTFIELD REKLAM İLETİŞİM ANONİM ŞİRKETİ (“Company”), we give utmost priority to the privacy and security of your
      personal data. In that regard, in order to fulfill our obligation of providing clarification, arising from article 10 of
      the Personal Data Protection Law numbered 6698 (“PDPL”), we would like to provide you information about your personal data.
      Personal data means any kind of information that makes you an identified or identifiable person.
    </p>

    <p class="z11">
      The Company’s web site that you visited (“Web Site”) uses cookies. A cookie is a small text file with a low size, mostly
      comprising of letters and numbers, which is stored on the terminal devices in use, so that the specific device can be detected.
    </p>

    <p class="z11">
      In connection with processing of your personal data that had been automatically obtained by placing the cookies used on our Web Site
      into your terminal devices, the purpose of this Clarification Text About Cookies is to give you information about the purposes for
      which we use these cookies and how you can manage them.
    </p>

    <div class="z11 uppercase">1. WHAT KIND OF COOKIES ARE USED BY THE COMPANY?</div>

    <p class="z11">
      The cookies can be divided into three groups: Cookies relating to purposes of use, cookies according to their terms, and cookies based on the parties.
    </p>

    <div class="z11 uppercase">1.1. Cookies relating to the purposes of use</div>

    <p class="z11">
      Our Company uses four types of cookies divided according to the purposes of use: Performance Assessment (Analytical) Cookies, Identification Cookies
      for Targeting, Functional Identification Cookies, and Compulsory Identification (Absolutely Necessary) Cookies.
    </p>

    <div class="z11 uppercase">1.1.1. Performance Assessment (Analytical) Cookies</div>

    <p class="z11">
      These cookies help us monitor site visits and traffic, learn about the most and least popular pages, and see how users navigate the site,
      so we can measure and improve performance. All information collected through these cookies is anonymized. If you do not permit these cookies,
      we cannot monitor your visit and its performance.
    </p>

    <div class="z11 uppercase">1.1.2. Identification Cookies for Targeting</div>

    <p class="z11">
      These cookies offer customized products depending on your preferences and interests. They may also be used by advertisement partners to develop
      a profile of your interests and display relevant ads. These cookies do not directly store personal data but help identify your browser and
      internet device. Without these cookies, you will see fewer targeted ads.
    </p>

    <div class="z11 uppercase">1.1.3. Functional Identification Cookies</div>

    <p class="z11">
      These cookies allow the Web Site to offer enhanced functionality and customization. They may be set by the Company or by third-party service providers.
      If you disable these cookies, some services may not function correctly. For example, language preference settings.
    </p>

    <div class="z11 uppercase">1.1.4. Compulsory Identification (Absolutely Necessary) Cookies</div>

    <p class="z11">
      These cookies are essential for the Web Site's operation and cannot be disabled in our systems. They are necessary to provide services such as logging-in,
      filling out forms, and managing privacy preferences. Blocking these cookies may impair the proper functioning of parts of the Web Site.
    </p>

    <div class="z11 uppercase">1.2. Cookies according to their term</div>

    <div class="z11 uppercase">1.2.1. Session (Nonpersistent) Cookies</div>

    <p class="z11">
      Session cookies ensure continuity during your visit and are deleted automatically when you close your browser.
      For example, a cookie used to identify your first-time visit.
    </p>

    <div class="z11 uppercase">1.2.2. Persistent Cookies</div>

    <p class="z11">
      Persistent cookies remain stored even after you close your browser and are deleted after a specific time or on a specified date.
      For example, these cookies help you stay logged-in to your account on the Web Site.
    </p>

    <div class="z11 uppercase">1.3. Cookies based on the parties</div>

    <p class="z11">
      <strong>1.3.1. First Party Cookies:</strong> Installed directly by the Web Site.<br>
      <strong>1.3.2. Third Party Cookies:</strong> Installed by advertisers or analytical systems with whom the Company collaborates.
    </p>

    <div class="z11 uppercase">2. LEGAL REASON AND PURPOSE OF COOKIE USAGE</div>

    <p class="z11">
      The Company processes personal data based on the legal requirements outlined in Article 5 of PDPL for purposes such as providing services,
      maintaining performance, protecting rights, and offering customized experiences.
    </p>

    <div class="z11 uppercase">3. PARTIES RECEIVING YOUR DATA AND PURPOSES OF SHARING</div>

    <p class="z11">
      The Company may share personal data with advertising technology providers and partners to offer customized ads or services.
      Data may also be shared with service providers and Google Analytics for analysis and improvements.
    </p>

    <div class="z11 uppercase">4. HOW CAN YOU CONTROL COOKIE USAGE?</div>

    <p class="z11">
      You can manage your cookie preferences through browser settings or visit external sites such as
      <a href="https://www.allaboutcookies.org">All About Cookies</a> or
      <a href="https://www.youronlinechoices.eu/">Your Online Choices</a>.
    </p>

    <div class="z11 uppercase">5. HOW DO WE PROTECT YOUR PERSONAL DATA?</div>

    <p class="z11">
      Personal data is protected using SSL encryption, access controls, and regular risk assessments to prevent unauthorized access.
    </p>

    <div class="z11 uppercase">6. CONTACT FOR YOUR RIGHTS AND REQUESTS</div>

    <p class="z11">
      You can contact the Data Controller regarding your personal data rights at: <strong>contact@artfieldofficial.com</strong>.
    </p>

    <div class="z11 uppercase">7. CHANGES TO THIS CLARIFICATION TEXT</div>

    <p class="z11">
      The Company reserves the right to update this text in accordance with changes in legislation. <strong>Updating Date: 01/10/2024</strong>
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  console.log('Terms of Service page loaded.');
});
</script>

<style scoped>
.z11:first-child {
  font-size: 20px;
}
.z11 {
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
}

.uppercase {
  text-transform: uppercase;
  margin-top: 20px;
  line-height: 20px;
  letter-spacing: .4px;
}
</style>
